// src/components/PatientPortalManagement/utils/api.js
import dayjs from "dayjs";

const API_URL = process.env.REACT_APP_API_URL;

// Build query params for listing invites
const buildQuery = ({ page, pageSize, emailQuery, dateRange }) => {
  const skip = (page - 1) * pageSize;
  const limit = pageSize;
  const params = new URLSearchParams();
  params.set("skip", skip);
  params.set("limit", limit);

  if (emailQuery) params.set("email", emailQuery);
  if (dateRange && dateRange.length === 2) {
    params.set("from", dateRange[0].toISOString());
    params.set("to", dateRange[1].toISOString());
  }

  return params.toString();
};

/**
 * Fetch all invites
 */
export const fetchInvites = async ({ page, pageSize, emailQuery, dateRange, token }) => {
  const qs = buildQuery({ page, pageSize, emailQuery, dateRange });
  const res = await fetch(`${API_URL}/portal/invites?${qs}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch invites: ${res.statusText}`);
  }
  return res.json(); // { data: [...], count: N }
};

/**
 * Revoke invite
 */
export const revokeInvite = async ({ inviteId, patientId, token }) => {
  const url = `${API_URL}/patients/${patientId}/portal/invite/${inviteId}/revoke`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  });

  if (res.ok) {
    return await res.json();
  }

  let errMsg = "";
  try {
    const data = await res.json();
    errMsg = data?.detail || JSON.stringify(data);
  } catch {
    errMsg = await res.text();
  }

  throw new Error(errMsg);
};

/**
 * Resend invite
 */
export const resendInvite = async ({ patientId, inviteId, token }) => {
  const url = `${API_URL}/patients/${patientId}/portal/invite/${inviteId}/resend`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  });

  if (res.ok) {
    return await res.json();
  }

  let errMsg = "";
  try {
    const data = await res.json();
    errMsg = data?.detail || JSON.stringify(data);
  } catch {
    errMsg = await res.text();
  }

  throw new Error(errMsg);
};

/**
 * Export invites as CSV
 */
export const exportInvitesCsv = (invites) => {
  if (!invites.length) return null;

  const rows = [
    ["invite_id", "patient_id", "email", "created_at", "expires_at", "revoked", "used"],
    ...invites.map((i) => [
      i.invite_id,
      i.patient_id,
      i.email,
      dayjs(i.created_at).format("YYYY-MM-DD HH:mm"),
      dayjs(i.expires_at).format("YYYY-MM-DD HH:mm"),
      i.revoked,
      i.used,
    ]),
  ];

  const csv = rows.map((r) => r.map((c) => `"${String(c ?? "")}"`).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  return url;
};
